import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const languages = [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
  { code: 'de', name: 'Deutsch' },
  { code: 'fr', name: 'Français' },
  { code: 'it', name: 'Italiano' },
];

const SUPPORTED_LANGUAGES = ['en', 'es', 'de', 'fr', 'it'];
const LANDING_PAGES = [
  'cleaner-scheduling-tool-for-airbnb-hosts',
  'airbnb-turnover-checklist-free-download',
  'airbnb-cleaning-schedule-software',
  'stop-airbnb-double-bookings',
  'turnoverbnb-alternative'
];

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLanguageChange = (newLang: string) => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const firstSegment = pathSegments[0];
    
    // If current URL has language prefix, replace it
    if (SUPPORTED_LANGUAGES.includes(firstSegment)) {
      pathSegments[0] = newLang;
      const newPath = `/${pathSegments.join('/')}${location.search}`;
      navigate(newPath);
      i18n.changeLanguage(newLang);
    } else {
      // For non-language-prefixed pages (like /portfolio, /auth),
      // just change i18n language without changing URL
      i18n.changeLanguage(newLang);
    }
  };

  return (
    <Select value={i18n.language} onValueChange={handleLanguageChange}>
      <SelectTrigger className="w-[100px] md:w-[140px]">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {languages.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            {lang.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
